import React, { Component } from "react";
import { connect } from "react-redux";
import { usStates } from "../../../../../common/_us_states";
import {
  createReference,
  saveReference,
  saveRenter,
  saveRenterAddress,
  updateRenter,
  updateRenterReference,
} from "../../duck/renter";
import * as Yup from "yup";
import { Header, Form, Message, Segment } from "semantic-ui-react";
import { CustomInputComponent } from "./CustomInputComponent";
import {
  referenceValidWithMessages,
  renterValidWithMessages,
} from "../../helpers/renterSchema";
import { AddressLookup } from "../../../../shared";

import { phoneRegex } from "helpers/validators";

class RenterForm extends Component {
  state = {
    messages: [],
    touched: [],
  };

  componentDidMount = () => {
    this.setMessages();
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.renter !== this.props.renter) {
      this.setMessages();
    }
  };

  setMessages = () => {
    renterValidWithMessages(this.props.renter).then((messages) => {
      this.setState({ messages });
    });

    if (this.props.renter.references) {
      this.props.renter.references.forEach((ref, i) => {
        referenceValidWithMessages(this.props.renter.references[i]).then(
          (messages) => {
            let refMessages = messages.map((m) => `Reference ${i + 1} - ${m}`);
            this.setState({
              messages: [...this.state.messages, ...refMessages],
            });
          }
        );
      });
    }
  };

  onAddressBlur = (e) => {
    this.props.dispatch(
      saveRenter(this.props.renter.id, { [e.target.name]: e.target.value })
    );
  };

  onAddressChange = (e) => {
    this.props.dispatch(updateRenter({ [e.target.name]: e.target.value }));

    if (e.target.name == "state" || e.target.name == "employer_state") {
      this.props.dispatch(
        saveRenter(this.props.renter.id, { [e.target.name]: e.target.value })
      );
    }
  };

  onAddressSelect = (addressData) => {
    delete addressData.lat;
    delete addressData.lng;
    delete addressData.county;

    const addressFormatted = {
      address_1: `${addressData.street_number} ${addressData.street_name}`,
      city: addressData.city,
      state: addressData.state,
      zip: addressData.zip,
    };

    this.props.dispatch(saveRenter(this.props.renter.id, addressFormatted));
  };

  onAddressEmployerSelect = (addressData) => {
    delete addressData.lat;
    delete addressData.lng;
    delete addressData.county;

    const addressFormatted = {
      employer_address_1: `${addressData.street_number} ${addressData.street_name}`,
      employer_city: addressData.city,
      employer_state: addressData.state,
      employer_zip: addressData.zip,
    };

    this.props.dispatch(saveRenter(this.props.renter.id, addressFormatted));
  };

  onChange = (e) => {
    this.setTouched(e.target.name);

    this.props.dispatch(
      updateRenter({
        // ...this.props.renter,
        [e.target.name]: e.target.value,
      })
    );

    if (e.target.name == "birthdate") {
      this.props.dispatch(
        saveRenter(this.props.renter.id, {
          [e.target.name]: e.target.value,
        })
      );
    }
  };

  onBlur = (e) => {
    this.setTouched(e.target.name);

    if (this.props.renter.id) {
      this.props.dispatch(
        saveRenter(this.props.renter.id, { [e.target.name]: e.target.value })
      );
    }
  };

  onReferenceChange = (e, idx) => {
    this.setTouched(e.target.name);

    let fieldName = "";

    if (idx === 0) {
      fieldName = e.target.name.replace("reference_1_", "");
    } else {
      fieldName = e.target.name.replace("reference_2_", "");
    }

    this.props.dispatch(
      updateRenterReference({
        name: fieldName,
        value: e.target.value,
        idx,
      })
    );
  };

  onReferenceBlur = (e, idx) => {
    const { renter } = this.props;

    let fieldName = "";

    if (idx === 0) {
      fieldName = e.target.name.replace("reference_1_", "");
    } else {
      fieldName = e.target.name.replace("reference_2_", "");
    }

    this.setTouched(e.target.name);

    // CREATE REFERENCE
    if (!renter.references[idx].id) {
      this.props.dispatch(
        createReference(this.props.id, renter.id, idx, {
          [fieldName]: e.target.value,
        })
      );
    } else {
      this.props.dispatch(
        saveReference(
          this.props.id,
          renter.references[idx].id,
          { [fieldName]: e.target.value },
          idx
        )
      );
    }
  };

  setTouched = (name) => {
    if (!this.state.touched.includes(name)) {
      this.setState({
        touched: [...this.state.touched, name],
      });
    }
  };

  render() {
    const { messages, touched } = this.state;

    const { renter } = this.props;

    const basicFields = [
      {
        name: "first_name",
        value: renter.first_name,
        label: "First Name",
        required: true,
        schema: () =>
          Yup.string()
            .min(2, "Too Short!")
            .max(50, "Too Long!")
            .required("Required"),
      },
      {
        name: "middle_name",
        value: renter.middle_name,
        label: "Middle Name",
        schema: () => Yup.string().min(2, "Too Short!").max(50, "Too Long!"),
      },
      {
        name: "last_name",
        value: renter.last_name,
        label: "Last Name",
        required: true,
        schema: () =>
          Yup.string()
            .min(2, "Too Short!")
            .max(50, "Too Long!")
            .required("Required"),
      },
      {
        name: "email",
        value: renter.email,
        label: "Email",
        required: true,
        schema: () => Yup.string().email("Invalid email").required("Required"),
      },
      {
        name: "home_phone",
        value: renter.home_phone,
        label: "Primary Phone Number",
        required: true,
        schema: () =>
          Yup.string()
            .matches(phoneRegex, "Phone number is not valid")
            .required("Required"),
      },
      {
        name: "drivers_license",
        value: renter.drivers_license,
        label: `Driver's License Number`,
        required: true,
        schema: () =>
          Yup.string()
            .min(2, "Too Short!")
            .max(50, "Too Long!")
            .required("Required"),
      },
      {
        name: "birthdate",
        value: renter.birthdate,
        label: "Birthdate",
        maxDate: new Date(),
        required: true,
        datepicker: true,
        schema: () => Yup.string().required("Required"),
      },
    ];

    const employerFields = [
      {
        name: "employer_name",
        value: renter.employer_name,
        label: "Employer Name",
        required: true,
        schema: () =>
          Yup.string()
            .min(2, "Too Short!")
            .max(50, "Too Long!")
            .required("Required"),
      },
      {
        name: "employer_phone",
        value: renter.employer_phone,
        label: "Employer Phone",
        required: true,
        schema: () =>
          Yup.string()
            .matches(phoneRegex, "Phone number is not valid")
            .required("Required"),
      },
    ];

    const reference1Fields = [
      // ref 1
      {
        name: "reference_1_first_name",
        value: renter.references[0].first_name,
        label: "Reference 1 First Name",
        required: true,
        schema: () =>
          Yup.string()
            .min(2, "Too Short!")
            .max(50, "Too Long!")
            .required("Required"),
      },
      {
        name: "reference_1_last_name",
        value: renter.references[0].last_name,
        label: "Reference 1 Last Name",
        required: true,
        schema: () =>
          Yup.string()
            .min(2, "Too Short!")
            .max(50, "Too Long!")
            .required("Required"),
      },
      {
        name: "reference_1_email",
        value: renter.references[0].email,
        label: "Reference 1 Email",
        schema: () => Yup.string().email("Invalid email"),
      },
      {
        name: "reference_1_phone",
        value: renter.references[0].phone,
        label: "Reference 1 Phone",
        required: true,
        schema: () =>
          Yup.string()
            .matches(phoneRegex, "Phone number is not valid")
            .required("Required"),
      },
      {
        name: "reference_1_relationship",
        value: renter.references[0].relationship,
        label: "Reference 1 Relationship",
        schema: () => Yup.string().min(2, "Too Short!").max(50, "Too Long!"),
      },
    ];

    const reference2Fields = [
      // ref 2
      {
        name: "reference_2_first_name",
        value: renter.references[1].first_name,
        label: "Reference 2 First Name",
        required: true,
        schema: () =>
          Yup.string()
            .min(2, "Too Short!")
            .max(50, "Too Long!")
            .required("Required"),
      },
      {
        name: "reference_2_last_name",
        value: renter.references[1].last_name,
        label: "Reference 2 Last Name",
        required: true,
        schema: () =>
          Yup.string()
            .min(2, "Too Short!")
            .max(50, "Too Long!")
            .required("Required"),
      },
      {
        name: "reference_2_email",
        value: renter.references[1].email,
        label: "Reference 2 Email",
        schema: () => Yup.string().email("Invalid email"),
      },
      {
        name: "reference_2_phone",
        value: renter.references[1].phone,
        label: "Reference 2 Phone",
        required: true,
        schema: () =>
          Yup.string()
            .matches(phoneRegex, "Phone number is not valid")
            .required("Required"),
      },
      {
        name: "reference_2_relationship",
        value: renter.references[1].relationship,
        label: "Reference 2 Relationship",
        schema: () => Yup.string().min(2, "Too Short!").max(50, "Too Long!"),
      },
    ];

    const allFields = [
      ...basicFields,
      ...employerFields,
      ...reference1Fields,
      ...reference2Fields,
    ];

    allFields.forEach((f) => {
      try {
        f.schema().validateSync(f.value);
        delete f.message;
      } catch (e) {
        f.message = e.message;
      }
    });

    return (
      <div>
        <Segment padded>
          <Header size="huge" textAlign="center" style={{ fontSize: "3em" }}>
            <Header.Content content="Renter Information" />
            <Header.Subheader>
              Required fields are marked with a{" "}
              <span style={{ color: "red" }}>*</span>
            </Header.Subheader>
          </Header>
          <Form size="large">
            <h2>Basic Information</h2>
            {basicFields.map((field, i) => (
              <CustomInputComponent
                datepicker={field.datepicker}
                error={!field.schema().isValidSync(field.value)}
                errorMessage={field.message}
                maxDate={field.maxDate}
                label={field.label}
                onBlur={this.onBlur}
                onChange={this.onChange}
                options={field.options}
                key={i}
                name={field.name}
                required={field.required}
                select={field.select}
                touched={touched.includes(field.name)}
                value={field.value}
              />
            ))}
            <AddressLookup
              address1={renter.address_1}
              address2={renter.address_2}
              city={renter.city}
              state={renter.state}
              zip={renter.zip}
              onBlur={this.onAddressBlur}
              onChange={this.onAddressChange}
              onSelect={this.onAddressSelect}
              showCounty={false}
            />
            <h2>Employer Information</h2>
            {employerFields.map((field, i) => (
              <CustomInputComponent
                datepicker={field.datepicker}
                error={!field.schema().isValidSync(field.value)}
                errorMessage={field.message}
                maxDate={field.maxDate}
                label={field.label}
                onBlur={this.onBlur}
                onChange={this.onChange}
                options={field.options}
                key={i}
                name={field.name}
                required={field.required}
                select={field.select}
                touched={touched.includes(field.name)}
                value={field.value}
              />
            ))}
            <AddressLookup
              address1Name="employer_address_1"
              address2Name="employer_address_2"
              cityName="employer_city"
              stateName="employer_state"
              zipName="employer_zip"
              address1={renter.employer_address_1}
              address2={renter.employer_address_2}
              city={renter.employer_city}
              state={renter.employer_state}
              zip={renter.employer_zip}
              onBlur={this.onAddressBlur}
              onChange={this.onAddressChange}
              onSelect={this.onAddressEmployerSelect}
              showCounty={false}
            />
            <h2>Reference 1 Information</h2>
            {reference1Fields.map((field, i) => (
              <CustomInputComponent
                datepicker={field.datepicker}
                error={!field.schema().isValidSync(field.value)}
                errorMessage={field.message}
                maxDate={field.maxDate}
                label={field.label}
                onBlur={(e) => this.onReferenceBlur(e, 0)}
                onChange={(e) => this.onReferenceChange(e, 0)}
                key={i}
                name={field.name}
                required={field.required}
                touched={touched.includes(field.name)}
                value={field.value}
              />
            ))}
            <h2>Reference 2 Information</h2>
            {reference2Fields.map((field, i) => (
              <CustomInputComponent
                datepicker={field.datepicker}
                error={!field.schema().isValidSync(field.value)}
                errorMessage={field.message}
                maxDate={field.maxDate}
                label={field.label}
                onBlur={(e) => this.onReferenceBlur(e, 1)}
                onChange={(e) => this.onReferenceChange(e, 1)}
                key={i}
                name={field.name}
                required={field.required}
                touched={touched.includes(field.name)}
                value={field.value}
              />
            ))}
          </Form>
        </Segment>
        {this.state.messages.length > 0 && (
          <Message
            icon="exclamation"
            header="There's some info missing here..."
            list={this.state.messages}
            warning
            size="large"
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    id: state.id,
    renter: state.renter,
  };
}

export default connect(mapStateToProps)(RenterForm);
